"use strict";

import React from "react";
import Head from "next/head";
import { I18nextProvider } from "react-i18next";
import { startI18n, getTranslation } from "../src/helpers/i18n";
import MyHead from "../src/components/MyHead";
import LostPasswordForm from "../src/components/LostPasswordForm";
import Footer from "./../src/components/Footer";
import SwitchLang from "./../src/components/SwitchLang";

export default class extends React.Component {
  static async getInitialProps({ req = {} }) {
    const { locale = process.env.DEFAULT_LANG } = req;
    const translations = await getTranslation(locale);

    return { locale, translations };
  }

  constructor(props) {
    super(props);
    this.i18n = startI18n(props.translations, props.locale);
  }

  render() {
    const { locale } = this.props;

    const title = this.i18n.t("HEAD_FORGOT_TITLE");

    return (
      <I18nextProvider i18n={this.i18n}>
        <div>
          <MyHead locale={locale} />
          <Head>
            <title>{title}</title>
            <meta name="og:title" content={title} />
          </Head>

          <section className="cont-100vh bg-gradient">
            <div className="switch-lang">
              <p>
                <SwitchLang route="forgot" />
              </p>
            </div>

            <div className="container login-page">
              <img
                src="/static/image/Icona+Naming_NeerU.svg"
                className="img-fluid u-center-horizontal"
                alt={title}
              />
              <LostPasswordForm locale={this.props.locale} />
            </div>
            <Footer fullWidth />
          </section>
        </div>
      </I18nextProvider>
    );
  }
}



// WEBPACK FOOTER //
// pages/forgot-password.js